import { render, staticRenderFns } from "./InsurerLoadingValues.vue?vue&type=template&id=5bba0b76"
import script from "./InsurerLoadingValues.vue?vue&type=script&lang=js"
export * from "./InsurerLoadingValues.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports